import { EnumField, FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import { EMPLOYEE_CONTRACT_TYPES } from 'domain/shared/employee';
import { SectionRow } from 'framework/ui/layout';
import VacancyOfficeField from 'domain/recruiting/vacancy/shared/field/VacancyOfficeField';
import { Box } from '@mui/material';
import { fieldWrapperSx } from 'framework/ui/styles';

const ExpectedCompensationField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const options = (getValue() || []) as any[];
  const getOptionInfo = (option: any) => {
    const office = <VacancyOfficeField value={option.office} label="Location (Office)" />;
    const contractType = (
      <EnumField value={option.contractType} options={EMPLOYEE_CONTRACT_TYPES} label="Contract Type" />
    );
    const valueRange = <TextField value={`${option.valueFrom} - ${option.valueTo}`} label="Value Range" />;
    const currency = <TextField value={option.currency} label="Currency" />;

    return (
      <Box className="field__item-wrapper" key={`${option.office}-${option.contractType}`}>
        <SectionRow>
          {office}
          {contractType}
          {valueRange}
          {currency}
        </SectionRow>
      </Box>
    );
  };

  const result = options.map((option: any) => getOptionInfo(option));

  return (
    <Box className="field__wrapper field__wrapper--column" sx={fieldWrapperSx}>
      {result}
    </Box>
  );
};

export default ExpectedCompensationField;
